import { StyledMessageBox } from './style';
import { MessageBoxProps } from './types';

function MessageBox({ title, text, fontFamily, borderColor }: MessageBoxProps) {
    return (
        <StyledMessageBox fontFamily={fontFamily} borderColor={borderColor}>
            <h2>{title}</h2>
            <p>{text}</p>
        </StyledMessageBox>
    );
}

export default MessageBox;
